(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('OrganisationNetworkController', OrganisationNetworkController);

    OrganisationNetworkController.$inject = ['$scope', 'Connexion', 'Principal', 'Network', 'Message', 'Profile'];

    function OrganisationNetworkController($scope, Connexion, Principal, Network, Message, Profile) {
        var vm = this;

        // Profiles de l'internal network, ie tous les commerciaux ou dg (faisant partie de l'organisation/meme dg de l'utilisateur) en relation avec la personne consultée.
        vm.connections = [];
        vm.people = null;

        vm.myNetworkOrganisationConnections = [];
        // Les employés de l'entreprise
        vm.myNetworkOrganisationPeople = [];

        vm.networkOrganisationConnuParConsultantPeople = null;

        vm.organisation = this.organisation;
        vm.profile = this.profile;

        // Profiles de l'external network, ie tous les consultants Axeenteev en relation avec la personne consultée
        vm.externalPeople = [];
        vm.externalConnections = [];
        // Grade du consultant le plus proche de la personne consultée
        vm.minGrade;

        vm.isAdmin;
        vm.isConsultant;
        vm.messageAdminsExternalNetwork = messageAdminsExternalNetwork;

        if (vm.organisation) init();

        function init() {
            Principal.profile().then(function(myProfile) {
                var isDgOrAdmin = Principal.hasAnyAuthority(['ROLE_DG', 'ROLE_ADMIN']);
                var isAdmin = Principal.hasAnyAuthority(['ROLE_ADMIN']);
                vm.isAdmin = Principal.hasAnyAuthority(['ROLE_ADMIN']);
                var isConsultant = Principal.hasAnyAuthority(['ROLE_CONSULTANT']);
                vm.isConsultant = Principal.hasAnyAuthority(['ROLE_CONSULTANT']);

                var isCommercial = Principal.hasAnyAuthority(['ROLE_COMMERCIAL']);
                vm.isCommercial = Principal.hasAnyAuthority(['ROLE_COMMERCIAL']);


                var isDg = Principal.hasAnyAuthority(['ROLE_DG']);
                vm.isDg = Principal.hasAnyAuthority(['ROLE_DG']);

                if (vm.profile) {
                    if (isAdmin) {
                        Connexion.externalNetwork({
                            profileId: vm.profile.id
                        }, function(connections) {
                            var network = externalNetwork(connections);
                            vm.externalPeople = network.people;
                            vm.externalConnections = network.connections;
                            vm.minGrade = network.minGrade;
                        });
                        Connexion.inverseNetworks({
                            profileId: vm.profile.id
                        }, function(connections) {
                            var network = internalNetworkDG(connections);
                            vm.people = network.people;
                            vm.connections = network.connections;
                        });
                    } else if (isDg) {
                        Connexion.internalNetworkDG({
                            profileId: vm.profile.id
                        }, function(connections) {
                            var network = internalNetworkDG(connections);
                            vm.people = network.people;
                            vm.connections = network.connections;
                        });

                        Connexion.externalNetwork({
                            profileId: vm.profile.id
                        }, function(connections) {
                            var network = externalNetwork(connections);
                            vm.externalPeople = network.people;
                            vm.externalConnections = network.connections;
                            vm.minGrade = network.minGrade;
                        });
                    } else {
                        if (isCommercial) {
                            // Commercial
                            Connexion.internalNetworkCommercial({
                                profileId: vm.profile.id
                            }, function(connections) {
                                var network = internalNetworkCommercial(connections);
                                vm.people = network.people;
                                vm.connections = network.connections;
                            });
                        }
                        Connexion.externalNetwork({
                            profileId: vm.profile.id
                        }, function(connections) {
                            var network = externalNetwork(connections);
                            vm.externalPeople = network.people;
                            vm.externalConnections = network.connections;
                            vm.minGrade = network.minGrade;
                        });
                    }
                } else {
                    if (isDg || isCommercial) {
                        Connexion.internalNetworkOfOrganisation({
                            organisationId: vm.organisation.id
                        }, function(connections) {
                            var network = internalNetworkOrganisation(connections);
                            vm.people = network.people;
                            vm.connections = network.connections;
                        });
                    }

                    Network.getList({
                        organisationId: vm.organisation.id
                    }, function(connections) {
                        var network = organisationNetwork(connections, myProfile.id);
                        // Les employés de l'entreprise
                        vm.myNetworkOrganisationPeople = network.people;
                        vm.myNetworkOrganisationConnections = network.connections;
                    });

                    if (isAdmin) {
                        Network.getListConnuParConsultant({
                            organisationId: vm.organisation.id
                        }, function(connections) {
                            var network = organisationNetwork(connections, myProfile.id);
                            // Les employés de l'entreprise
                            vm.networkOrganisationConnuParConsultantPeople = network.people;
                        });
                    }
                }
            });
        }

        function organisationNetwork(connections, myProfileId) {
            var res = {
                connections: [],
                people: []
            };
            connections.forEach(function(connection) {
                var person;
                if (connection.target.id === myProfileId) {
                    person = connection.creator;
                } else {
                    person = connection.target;
                }

                person.grade = connection.grade;
                person.connectionId = connection.id;
                res.connections.push(connection);


                // On position la current position pour le lien vers le profile en multiaffichage
                if (!person.positions) {
                    console.warn("positions is nul for profile");
                    console.log(person);
                }
                person.positions && person.positions.forEach(function(p) {
                    if (!p.organisation) {
                        console.warn("organisation is nul for position");
                        console.log(p);
                    }
                    if (p.organisation && p.organisation.id === vm.organisation.id){
                        person.currentPosition = p;
                    }
                });

                if (!res.people.some(function(e) { return e.id === person.id })) {
                    res.people.push(person);
                }

            });
            return res;
        }

        function internalNetworkDG(connections) {
            var res = {
                connections: [],
                people: []
            };
            connections.forEach(function(connection) {
                var person;

                // N002 - Mon Network - Mon réseau - Réseaux indépendants DG et commercial
                // Mise en commentaire, je ne comprend pas ce test
                /*
                if (connection.target.id === myProfileId) {
                    person = connection.creator;
                } else {
                    person = connection.target;
                }
                */

                person = connection.creator;
                person.grade = connection.grade;
                person.connectionId = connection.id;
                if (!res.connections.some(function(e) { return e.id === connection.id })) {
                    res.connections.push(connection);
                }

                // On position la current position pour le lien vers le profile en multiaffichage
                if (!person.positions) {
                    console.warn("positions is nul for profile");
                    console.log(person);
                }
                person.positions && person.positions.forEach(function(p) {
                    if (!p.organisation) {
                        console.warn("organisation is nul for position");
                        console.log(p);
                    }
                    if (p.organisation && p.organisation.id === vm.organisation.id){
                        person.currentPosition = p;
                    }
                });

                if (!res.people.some(function(e) { return e.id === person.id })) {
                    res.people.push(person);
                }
            });
            return res;
        }



        function internalNetworkOrganisation(connections) {
            var res = {
                connections: [],
                people: []
            };
            connections.forEach(function(connection) {
                var person;
                /*
                if (connection.target.id === myProfileId) {
                    person = connection.creator;
                } else {
                    person = connection.target;
                }
                */
                // N002 - Mon Network - Mon réseau - Réseaux indépendants DG et commercial
                // Mise en commentaire, je ne comprend pas ce test
                /*
                if (connection.target.id === myProfileId) {
                    person = connection.creator;
                } else {
                    person = connection.target;
                }
                */

                person = connection.target;
                person.grade = connection.grade;
                person.connectionId = connection.id;
                if (!res.connections.some(function(e) { return e.id === connection.id })) {
                    res.connections.push(connection);
                }

                // On position la current position pour le lien vers le profile en multiaffichage
                if (!person.currentPosition) {
                    if (!person.positions) {
                        console.warn("positions is nul for profile");
                        console.log(person);
                    }
                    person.positions && person.positions.forEach(function(p) {
                        if (p.organisation && p.organisation.id === vm.organisation.id){
                            person.currentPosition = p;
                        }
                    });

                    person.positions && !person.currentPosition && person.positions.forEach(function(p) {
                        if (p.active){
                            person.currentPosition = p;
                        }
                    });

                }


                if (!res.people.some(function(e) { return e.id === person.id })) {
                    res.people.push(person);
                }
            });
            return res;
        }


        function internalNetworkCommercial(connections) {
            var res = {
                connections: [],
                people: []
            };

            connections.forEach(function(connection) {
                var person;

                // N002 - Mon Network - Mon réseau - Réseaux indépendants DG et commercial
                // Mise en commentaire, je ne comprend pas ce test
                /*
                if (connection.target.id === myProfileId) {
                    person = connection.creator;
                } else {
                    person = connection.target;
                }
                */

                person = connection.creator;
                person.grade = connection.grade;
                person.connectionId = connection.id;
                if (!res.connections.some(function(e) { return e.id === connection.id })) {
                    res.connections.push(connection);
                }

                // On position la current position pour le lien vers le profile en multiaffichage
                if (!person.positions) {
                    console.warn("positions is nul for profile");
                    console.log(person);
                }
                person.positions && person.positions.forEach(function(p) {
                    if (!p.organisation) {
                        console.warn("organisation is nul for position");
                        console.log(p);
                    }
                    if (p.organisation && p.organisation.id === vm.organisation.id){
                        person.currentPosition = p;
                    }
                    person.positions && !person.currentPosition && person.positions.forEach(function(p) {
                        if (p.active){
                            person.currentPosition = p;
                        }
                    });
                });

                if (!res.people.some(function(e) { return e.id === person.id })) {
                    res.people.push(person);
                }
            });
            return res;
        }

        function internalNetworkAdmin(connections) {
            var res = {
                connections: [],
                people: []
            };
            connections.forEach(function(connection) {
                var person;

                // N002 - Mon Network - Mon réseau - Réseaux indépendants DG et commercial
                // Mise en commentaire, je ne comprend pas ce test
                /*
                if (connection.target.id === myProfileId) {
                    person = connection.creator;
                } else {
                    person = connection.target;
                }
                */

                person = connection.creator;
                person.grade = connection.grade;
                person.connectionId = connection.id;
                res.connections.push(connection);


                // On position la current position pour le lien vers le profile en multiaffichage
                if (!person.positions) {
                    console.warn("positions is nul for profile");
                    console.log(person);
                }
                person.positions && person.positions.forEach(function(p) {
                    if (!p.organisation) {
                        console.warn("organisation is nul for position");
                        console.log(p);
                    }
                    if (p.organisation && p.organisation.id === vm.organisation.id){
                        person.currentPosition = p;
                    }
                });

                res.people.push(person);
            });
            return res;
        }

        function externalNetwork(connections) {
            var res = {
                connections: [],
                people: [],
                // "Axenteev connait en $minGrade cette personne"
                minGrade: 3
            };

            connections.forEach(function(connection) {
                var person;

                // N002 - Mon Network - Mon réseau - Réseaux indépendants DG et commercial
                // Mise en commentaire, je ne comprend pas ce test
                /*
                if (connection.target.id === myProfileId) {
                    person = connection.creator;
                } else {
                    person = connection.target;
                }
                */
                if (connection.creator)
                    person = connection.creator;
                person.grade = connection.grade;
                if (connection.grade < res.minGrade) {
                    res.minGrade = connection.grade;
                }
                person.connectionId = connection.id;
                res.connections.push(connection);


                // On position la current position pour le lien vers le profile en multiaffichage
                if (!person.positions) {
                    console.warn("positions is nul for profile");
                    console.log(person);
                }
                person.positions && person.positions.forEach(function(p) {
                    if (!p.organisation) {
                        console.warn("organisation is nul for position");
                        console.log(p);
                    }
                    if (p.organisation && p.organisation.id === vm.organisation.id){
                        person.currentPosition = p;
                    }
                });

                res.people.push(person);
            });
            return res;
        }

        function messageAdminsExternalNetwork(profile) {
            console.log(profile.id);

            Message.messageRequestExternalNetwork(profile, function(result) {
                console.log(result);
            });
        }

    }
})();
